import React from "react";
import './Home.scss';

const Home = () => {
    return (
        <div className="home" >
            <h3 className="home__hi">Hi! :)</h3>
            <h4>I'm Denise, nice to meet you!</h4>
            <span>I write code.</span><br />
            <span>I read books.</span><br />
            <span>I do stuff.</span>
        </div>
    )
}

export default Home
